var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"mb-5 text-center"},[_vm._v(_vm._s(_vm.page.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }